<div class="scrn">
  <div class="abs_center stout">
    <div class="title">
      Select task to edit
    </div>
    <div class="lines" [ngClass]="{save:btn == 'Save'}">
      <div class="line" *ngFor="let task of _tasks;let i = index">
        <div class="btn" (click)="play(i)">
          <div class="abs_center">
            {{task.name}}
          </div>
        </div>
      </div>
    </div>
    <input *ngIf="btn == 'Save'" kzInput class="in fl" type="text" placeholder="Enter task name" [(ngModel)]="task_name">

    <div class="btn last" (click)="addTask()" [ngClass]="{disabled:btn == 'Save'&&task_name.length<2}">
      <div class="abs_center">
        {{btn}}
      </div>
    </div>
    <img src="assets/images/close.svg" class="close" kzLib (click)="closeIt()" />
  </div>

</div>
